import { SeasonService } from '@modules/season/season-service';
import RelationToOneField from '@shared/fields/relation-to-one-field';
import RelationToManyField from '@shared/fields/relation-to-many-field';
import Permissions from '@security/permissions';

export class SeasonField {
  static relationToOne(name, label, options) {
    return new RelationToOneField(
      name,
      label,
      '/season',
      Permissions.values.seasonRead,
      SeasonService.listAutocomplete,
      (record) => {
        if (!record) {
          return null;
        }

        return {
          id: record.id,
          label: record.name,
        };
      },
      options,
    );
  }

  static relationToMany(name, label, options) {
    return new RelationToManyField(
      name,
      label,
      '/season',
      Permissions.values.seasonRead,
      SeasonService.listAutocomplete,
      (record) => {
        if (!record) {
          return null;
        }

        return {
          id: record.id,
          label: record.name,
        };
      },
      options,
    );
  }
}
